/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPushFormRequest
 */
export interface ControlPushFormRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ControlPushFormRequest
     */
    custom_fields?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ControlPushFormRequest interface.
 */
export function instanceOfControlPushFormRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPushFormRequestFromJSON(json: any): ControlPushFormRequest {
    return ControlPushFormRequestFromJSONTyped(json, false);
}

export function ControlPushFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPushFormRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'custom_fields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
    };
}

export function ControlPushFormRequestToJSON(value?: ControlPushFormRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.custom_fields,
    };
}

